import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Snackbar, SnackbarContent } from '@material-ui/core';
import TooltipIconButton from './TooltipIconButton';
import { seedMySnackbarIcons } from '../icon/seed-icons';

const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.error.contrastText,
  },
  info: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  iconMessage: {
    marginRight: theme.spacing(1),
  },
}));

const getIcon = (variant, icons) => {
  const snackbarIcons = {
    success: icons.CheckCircle,
    warning: icons.Warning,
    error: icons.Error,
    info: icons.Info,
    default: null,
  };
  return snackbarIcons[variant];
};

const MySnackbar = (props) => {
  const {
    message,
    onClose,
    open,

    anchorOrigin,
    variant,
    icons,
    ...rest
  } = props;
  const classes = useStyles();
  const Icon = getIcon(variant, icons);

  const actions = [];
  actions.push(
    <TooltipIconButton
      key="snackbar-close"
      color="inherit"
      icon={<icons.Close />}
      onClick={onClose}
      title="Close"
    />,
  );

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={onClose}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <SnackbarContent
        className={clsx(classes[variant])}
        message={(
          <span className={classes.message}>
            {
              variant === 'default' ? null : (
                <Icon className={classes.iconMessage} />
              )
            }
            {message}
          </span>
        )}
        action={actions}
      />
    </Snackbar>
  );
};

MySnackbar.propTypes = {
  message: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,

  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'center', 'right']),
    vertical: PropTypes.oneOf(['top', 'bottom']),
  }),
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'default']),
  icons: PropTypes.shape({
    CheckCircle: PropTypes.object.isRequired,
    Warning: PropTypes.object.isRequired,
    Error: PropTypes.object.isRequired,
    Info: PropTypes.object.isRequired,
    Close: PropTypes.object.isRequired,
  }),
};

MySnackbar.defaultProps = {
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'bottom',
  },
  variant: 'default',
  icons: seedMySnackbarIcons,
};

export default MySnackbar;
